export default __webpack_public_path__ + "static/media/photoRando.f36b9646.png";